import { render, staticRenderFns } from "./ProgramacionInformePantalla.vue?vue&type=template&id=679a67b4&"
import script from "./ProgramacionInformePantalla.vue?vue&type=script&lang=ts&"
export * from "./ProgramacionInformePantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports